import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { dokKeys, useMe } from '../hooks/data.js';
import { useToast } from './toast.jsx';
import { entwuerfeSenden, onEntwurf, vorgemerkteEntwuerfe } from '../lib/entwuerfe.js';
import { fotosAufraeumen } from '../lib/fotospeicher.js';

const NOCHMAL_MS = 30_000;

/**
 * Speichert vorgemerkte Formulare (ohne Netz «Vormerken») automatisch: beim Start, nach der Anmeldung, beim
 * Wiederverbinden und alle 30 s, solange etwas wartet. Meldet das Ergebnis und lädt Liste und Dokument neu.
 */
export function FormularSync() {
  const qc = useQueryClient();
  const toast = useToast();
  const uid = useMe().data?.uid ?? null;

  useEffect(() => onEntwurf((e) => {
    if (e.art === 'gespeichert') {
      const [liste, dok] = dokKeys(e.ziel.art);
      qc.invalidateQueries({ queryKey: [liste, e.ziel.nr] });
      qc.invalidateQueries({ queryKey: [dok, e.ziel.nr] });
      qc.invalidateQueries({ queryKey: ['dateien', e.ziel.nr], refetchType: 'none' });
      toast({ text: `«${e.ergebnis.daten?.titel ?? 'Formular'}» gespeichert (war auf dem Gerät vorgemerkt)` });
    }
    if (e.art === 'fehler') toast({ text: `Nicht gespeichert: ${e.fehler}`, error: true, long: true });
  }), [qc, toast]);

  // Fotos verworfener Entwürfe vom Gerät entfernen
  useEffect(() => { fotosAufraeumen(); }, []);

  useEffect(() => {
    if (!uid) return undefined;
    const run = () => { if (navigator.onLine !== false && vorgemerkteEntwuerfe().length) entwuerfeSenden(); };
    run();
    window.addEventListener('online', run);
    const t = setInterval(run, NOCHMAL_MS);
    return () => { window.removeEventListener('online', run); clearInterval(t); };
  }, [uid]);

  return null;
}
